import type { PlacementDefinition } from '@/lib/catalogData';

export type PlacementCatalogRow = {
  id: string;
  name: string;
  position: string;
  description: string;
  one_issue: number;
  three_issue: number;
  capacity: number;
  default_filled: number;
  premium: boolean;
  features: string[] | null;
  color: string;
  mockup_position: string;
  sort_order: number;
  is_active: boolean;
  is_flyer_insert?: boolean;
};

const allowedColors = new Set(['brand', 'sky', 'violet', 'amber', 'gradient']);
const allowedMockupPositions = new Set([
  'interior',
  'inside-front',
  'inside-back',
  'back',
  'front',
]);

export function mapPlacementRowToDefinition(row: PlacementCatalogRow): PlacementDefinition {
  return {
    id: row.id as PlacementDefinition['id'],
    name: row.name,
    position: row.position,
    description: row.description,
    oneIssue: Number(row.one_issue) || 0,
    threeIssue: Number(row.three_issue) || 0,
    capacity: Number(row.capacity) || 0,
    defaultFilled: Number(row.default_filled) || 0,
    premium: Boolean(row.premium),
    features: Array.isArray(row.features) ? row.features : [],
    color: allowedColors.has(row.color) ? (row.color as PlacementDefinition['color']) : 'brand',
    mockupPosition: allowedMockupPositions.has(row.mockup_position)
      ? (row.mockup_position as PlacementDefinition['mockupPosition'])
      : 'interior',
    isFlyerInsert: row.id === 'flyer_insert' || row.id === 'premium_flyer_insert' || Boolean(row.is_flyer_insert),
  };
}

export function mapDefinitionToPlacementPayload(def: PlacementDefinition, sortOrder: number) {
  return {
    id: def.id,
    name: def.name,
    position: def.position,
    description: def.description,
    one_issue: def.oneIssue,
    three_issue: def.threeIssue,
    capacity: def.capacity,
    default_filled: def.defaultFilled,
    premium: def.premium,
    features: def.features,
    color: def.color,
    mockup_position: def.mockupPosition,
    sort_order: sortOrder,
    is_active: true,
  };
}
